import temperatureIcon from "./../../../images/icons/ic_temp.48.png"
import humidityIcon from "./../../../images/icons/ic_humidity_48.png"
import airPressureIcon from "./../../../images/icons/ic_air.p_48.png"

import enArmAudio from './../../../audio/is_armed.mp3';
import enDisarmAudio from './../../../audio/is_disarmed.mp3';
import enStayArmAudio from './../../../audio/stay.mp3';
import enAreaAudio from './../../../audio/area.mp3';
import enPanicAudio from './../../../audio/panic.mp3';
import frArmAudio from './../../../audio/fr/is_armed_fr.mp3';
import frDisarmAudio from './../../../audio/fr/is_disarmed_fr.mp3';
import frStayArmAudio from './../../../audio/fr/stay_fr.mp3';
import frAreaAudio from './../../../audio/fr/area_fr.mp3';
import frPanicAudio from './../../../audio/fr/panic_fr.mp3';
import GenericController from './generic.controller'

export default class Controller extends GenericController {

    static get $inject() {
        return [
            '$rootScope', '$timeout', 'ApiPanelsService', 'RemoteAccessService', 'ControlPanelConfigService', '$filter',
            '$q', 'LanguageService', '$state', 'UiHelper', 'gettext', '$element', 'PermissionsService', '$stateParams',
            'toaster', 'ApiAccountService', '$scope', 'ModalDialogService', '$interval', 'moment', 'UserCodeModalService',
            'UserCodeService', 'CountdownService', '$localStorage', 'CookiesService', 'panel', '$window', 'WebSocket',
            'ConfigEmailNotificationService', 'UtilsService', 'ExternalService'
        ];
    }

    constructor($rootScope, $timeout, ApiPanelsService, RemoteAccessService, ControlPanelConfigService, $filter,
                $q, LanguageService, $state, UiHelper, gettext, $element, PermissionsService, $stateParams,
                toaster, ApiAccountService, $scope, ModalDialogService, $interval, moment, UserCodeModalService,
                UserCodeService, CountdownService, $localStorage, CookiesService, panel, $window, WebSocket,
                ConfigEmailNotificationService, UtilsService, ExternalService) {

        super($rootScope, $timeout, ApiPanelsService, RemoteAccessService, ControlPanelConfigService, $filter,
              $q, LanguageService, $state, UiHelper, gettext, $element, PermissionsService, $stateParams,
              toaster, ApiAccountService, $scope, ModalDialogService, $interval, moment, UserCodeModalService,
              UserCodeService, CountdownService, ConfigEmailNotificationService, UtilsService);

        $window.scrollTo(0, 0); //scroll to top of the page (for xs and mobile use)
        this.$localStorage = $localStorage;
        this._$timeout = $timeout;
        this.$filter = $filter;
        this.gettext = gettext;
        this._RemoteAccessService = RemoteAccessService;
        this._CookiesService = CookiesService;

        this.$rootScope = $rootScope;
        this.panel = panel;
        this.currentControlPanel = this.panel.control_panel;
        this.$rootScope.panelId = this.panelId = this.currentControlPanel.mac;
        this.$rootScope.version = this.VERSION = this.currentControlPanel.version || '';
        this.$rootScope.panelName = this.panel.name;
        this.$rootScope.mac = this.mac = this.currentControlPanel.mac;
        this.$rootScope.remoteAccessPassword = this.currentControlPanel.remote_access_password;
        this.$rootScope.currentLoggedInUser = this.panel.user.username;
        this.$rootScope.isPanicEnabled = this.panel.control_panel.panic_enabled;
        this._statisticGraphChartBindToName = 'THPchartFromMainBar';
        this.$rootScope._isViewingAsOtherUser = this.ApiAccountService.getUserName() != this.$rootScope.currentLoggedInUser;
        this.isPhonesConfigurable  = UtilsService.versionCompare(this.VERSION, '0.9.82.0') >= 0 && !this.isSerenityPanel();
        this.$scope.isVersion84Upper = this.UtilsService.versionCompare(this.VERSION, '0.9.84.0') >= 0;

        this.$state = $state;
        this.$scope = $scope;
        this.SockObj = this.selectedZone = null;
        this.latestDectHomeAutomationMeasurements = [];
        this.getLatestByZoneDectHomeAutomationMeasurements();
        this.stateFull = this.currentControlPanel.state_full;
        this.pairType = this.currentControlPanel.pair_type;
        this.$rootScope.isConnected = this.isPanelConnected();
        this.isConnected = this.$rootScope.isConnected;
        this.setAudioLanguage()

        this.CONNECTION_TEXT = [gettext('connected'), gettext('disconnected'), gettext('disconnected')];
        this.AIR_QAULITY_TEXT = [gettext('Hazard'), gettext('Very Bad'), gettext('Unhealthy'), gettext('Moderate'), gettext('OK'), gettext('Clean')];

        // Page sub-pages
        this.pages = [
            {
                connectedOnly: this.isConnected,
                name: 'areas',
                humanName: gettext('Areas'),
                singularCapital: gettext('Area'),
                singularSmall: gettext('area')
            },
            {
                connectedOnly: this.isConnected,
                name: 'zones',
                humanName: gettext('Zones'),
                singularCapital: gettext('Zone'),
                singularSmall: gettext('zone')
            },
            {
                connectedOnly: this.isConnected,
                name: 'outputs',
                humanName: gettext('Outputs'),
                singularCapital: gettext('Output'),
                singularSmall: gettext('output')
            },
            {
                connectedOnly: this.isConnected,
                name: 'keypads',
                humanName: gettext('Keypads'),
                singularCapital: gettext('Keypads'),
                singularSmall: gettext('keypad')
            },
            {
                connectedOnly: this.isConnected,
                name: 'users',
                humanName: gettext('Users'),
                singularCapital: gettext('Users'),
                singularSmall: gettext('users')
            },
            {
                connectedOnly: this.isConnected,
                name: 'troubles',
                humanName: gettext('Troubles'),
                singularCapital: gettext('Trouble'),
                singularSmall: gettext('trouble')
            },
            {connectedOnly: true, name: 'pictures', humanName: gettext('Pictures')},
        ];

        // Check for external integrations:
        ExternalService.getExternals(panel.control_panel.id)
            .then(externals => {
                externals.forEach(ex => {
                    this.pages.push({connectedOnly: true, name: ex.name, humanName: gettext(ex.title)})
                })
            });


        if(this.$scope.isVersion84Upper) {
            this.pages.push(            {
                connectedOnly: this.isConnected,
                name: 'door locks',
                humanName: gettext('Door Locks'),
                singularCapital: gettext('Door Lock'),
                singularSmall: gettext('door lock')
            })
        }

        if (this.isSerenityPanel()) {
            this.pages = _.filter(this.pages, (p) => {
                return p.name != 'keypads'
            })
        }

        this.dropdownSettings = [
            {connectedOnly: true, name: 'panelInfo', humanName: gettext('Panel Info')},
            {connectedOnly: true, name: 'cloudAccounts', humanName: gettext('Cloud Accounts')},
            {connectedOnly: true, name: 'notifications', humanName: gettext('Notifications')},
            {connectedOnly: true, name: 'panelDetails', humanName: gettext('Details')},
            {connectedOnly: true, name: 'installerAccess', humanName: gettext('Installer Access')},
            {connectedOnly: true, name: 'scheduler', humanName: gettext('Scheduler')},
            {connectedOnly: true, name: 'emergencyPhones', humanName: gettext('Emergency Phones')},
            {connectedOnly: this.isPhonesConfigurable, name: 'phones', humanName: gettext('Voice / SMS Phones')},
        ];

        for (let index = 0; index < this.pages.length; index++) {
            this.pages[index]['id'] = index;
        }
        for (let index = 0; index < this.dropdownSettings.length; index++) {
            this.dropdownSettings[index]['id'] = index + this.pages.length;
        }
        this.GraphText = [gettext('Day'), gettext('Hour'), gettext('Week'), gettext('Month'),
            gettext('air_pressure statistics'), gettext('humidity statistics'), gettext('air_quality statistics'),
            gettext('temperature statistics'), gettext('air_quality_level statistics'),
            gettext('air quality level statistics'), gettext('Air Quality'), gettext('Temperature'),
            gettext('Zone statistics'), gettext('Humidity'), gettext('Air Pressure'), gettext('energy statistics'),
            gettext('amperage statistics'), gettext('voltage statistics'), gettext('instantaneous_power statistics'),
            gettext('average_power statistics'), gettext('frequency statistics'),];

        // App messages
        this.messages = {};

        // Connection status
        this.connected = this.connecting = this.isConnected;
        let cookiePagSTATUSES = this.getCurrentPage();

        if (this.isConnected == false) {

            this.cp = this.pages[5];

        }
        else {

            this.cp = this.pages[cookiePagSTATUSES || 0];
            if (!this.cp) {
                for (let page of this.dropdownSettings) {
                    let pageId = page['id'].toString();
                    if (pageId == cookiePagSTATUSES) {
                        this.cp = this.dropdownSettings[page.id - this.pages.length];
                        break;
                    }
                }
            }
        }

        this.panelDisarmedByUserEvent = this.$rootScope.$on('panelDisarmedByUser', (e, event) => {
            this.CountdownService.stopArmProcessCountdown();
        });
        this.panelStayDisarmedByUserEvent = this.$rootScope.$on('panelStayDisarmedByUser', (e, event) => {
            this.CountdownService.stopArmProcessCountdown();
        });

        $element.on('$destroy', () => {
            this.panelDisarmedByUserEvent();
            this.panelStayDisarmedByUserEvent();
            this.closeModal('languageModal');
            this.closeModal('zoneGraphModal2');
            this.closeModal('GenericStatisticsModal');
        });

        $scope.$on('openTroubles', () => {
            this.changePage(_.find(this.pages, {name: 'troubles'}))
        });

        WebSocket.webSocketConnect(this.currentControlPanel.id);
    }

    _setFrAudio() {
        this.armAudio = frArmAudio;
        this.disarmAudio = frDisarmAudio;
        this.stayArmAudio = frStayArmAudio;
        this.areaAudio = frAreaAudio;
        this.panicAudio = frPanicAudio;
    }

    setAudioLanguage() {
        let language = this.$localStorage.language;

        if(language === 'fr') {
            this._setFrAudio();
        } else {
            this.armAudio = enArmAudio;
            this.disarmAudio = enDisarmAudio;
            this.stayArmAudio = enStayArmAudio;
            this.areaAudio = enAreaAudio;
            this.panicAudio = enPanicAudio;
        }
    }


    isUserPickedDectStatisticsDevice() {
        return _.has(this.$localStorage.dectStatistics, this.panelId);
    }

    dectStatisticsDeviceCacheCheck() {
        if (!this.$localStorage.dectStatistics || _.isEmpty(this.$localStorage.dectStatistics)) {

            this.$localStorage.dectStatistics = {};
            this.selectedZone = _.find(this.latestByZoneDectHomeAutomationMeasurements);
        }
        else if (this.isUserPickedDectStatisticsDevice()) {

            let userChosenDectDeviceId = this.$localStorage.dectStatistics[this.panelId];

            this.selectedZone = this.latestByZoneDectHomeAutomationMeasurements[userChosenDectDeviceId];
        }
    }

    setGasLevelStyleId() {
        let gasLevel = _.get(this.latestDectHomeAutomationMeasurements, 'gas_value.level');

        if (gasLevel > 300) {
            this.$scope.gasLevel = 5;
            this.$scope.gasLevelText = 'Hazard';
        } else if (gasLevel > 200) {
            this.$scope.gasLevel = 4;
            this.$scope.gasLevelText = 'Very Bad';
        } else if (gasLevel > 150) {
            this.$scope.gasLevel = 3;
            this.$scope.gasLevelText = 'Unhealthy';
        } else if (gasLevel > 100) {
            this.$scope.gasLevel = 2;
            this.$scope.gasLevelText = 'Moderate';
        } else if (gasLevel > 50) {
            this.$scope.gasLevel = 1;
            this.$scope.gasLevelText = 'OK';
        } else {
            this.$scope.gasLevel = 0;
            this.$scope.gasLevelText = 'Clean';
        }
    }

    _setLatestDectHomeAutomationMeasurements(selectedZone) {
        let newLatestMeasurements = {};

        _.forEach(selectedZone.values, (innerMeasureObject) => {

            let currentMeasureKeys = _.pull(_.keys(innerMeasureObject), '_id', 'id');
            _.forEach(currentMeasureKeys, function (key) {
                newLatestMeasurements[key] = {'level': innerMeasureObject[key], '_id': innerMeasureObject['_id']};
            })
        });

        this.latestDectHomeAutomationMeasurements = newLatestMeasurements;
        this.setGasLevelStyleId();
    }

    getLatestByZoneDectHomeAutomationMeasurements() {
        this._RemoteAccessService.getLatestByZoneDectHomeAutomationMeasurements(this.$rootScope.mac)
            .then(resp => {

                this.latestByZoneDectHomeAutomationMeasurements = resp.data;
                this.latestByZoneDectHomeAutomationMeasurementsLength = Object.keys(this.latestByZoneDectHomeAutomationMeasurements).length;

                if (!this.isLatestByDectHomeAutomationMeasurementsEmpty()) {

                    this.dectStatisticsDeviceCacheCheck();
                    this._setLatestDectHomeAutomationMeasurements(this.selectedZone);
                }
            })
            .catch(err => {
                //todo: handle catch
            });
    }

    isLatestByDectHomeAutomationMeasurementsEmpty() {
        let latestList = this.latestByZoneDectHomeAutomationMeasurements;
        this.isLatestByZoneDectMeasurementsEmpty = _.isEmpty(latestList) || latestList == undefined;

        return this.isLatestByZoneDectMeasurementsEmpty;

    }

    get temperatureIcon() {
        return temperatureIcon;
    }

    get humidityIcon() {
        return humidityIcon;
    }

    get airPressureIcon() {
        return airPressureIcon;
    }

    isPanelConnected() {
        let isStateFull = this.stateFull == 1 || this.stateFull == 2;
        let isPaired = this.pairType == null || this.pairType == 2;

        return isPaired && isStateFull;
    }

    changePage(page) {
        if (this.pages.find(v => v.id === page.id)) {
            this.cp = this.pages.find(v => v.id === page.id);
        } else if (this.dropdownSettings.find(v => v.id === page.id)) {
            this.cp = this.dropdownSettings.find(v => v.id === page.id);
        }

        this._CookiesService.setCookie('currentPage', page.id);
    }

    getCurrentPage() {
        return this._CookiesService.getCookie('currentPage');
    }

    getCurrentPageText() {
        let currentPageId = this.getCurrentPage();
        for (var page of this.pages) {
            if (page.id == currentPageId) return this.getTranslatableText(page.humanName);
        }
    }

    settingsDropdownSelected(page) {
        return !!(page && this.dropdownSettings.find(v => v.id === page.id));
    }

    // --- Private -----------------------------------------------------------------------------------------------------

    _getStatus() {
        if (!this.connected) {
            return;
        }
        this._RemoteAccessService.getStatus();
    }

    _setConnectedStatus(connected, connecting) {
        this.connected = !!connected;
        this.connecting = !!connecting;
    }

    setCurrentDeviceStatisticsParams(graphTypeStr) {
        let dectTHPZoneType = null;
        let dectTHPZoneId = this.latestDectHomeAutomationMeasurements[graphTypeStr]._id.device_id;

        if (this.latestDectHomeAutomationMeasurements[graphTypeStr]._id.dect_interface === 32770) {
            dectTHPZoneType = 65
        }
        else if (this.latestDectHomeAutomationMeasurements[graphTypeStr]._id.dect_interface === 77) {
            dectTHPZoneType = 77
        }
        else if (_.has(this.latestDectHomeAutomationMeasurements, 'gas_value') || _.has(this.latestDectHomeAutomationMeasurements, 'gas_level')) {
            dectTHPZoneType = 61
        }
        else if (this.latestDectHomeAutomationMeasurements[graphTypeStr]._id.dect_interface === 72) {
            dectTHPZoneType = 72
        }
        else {
            dectTHPZoneType = 58
        } // THP and air quality

        super.setCurrentDeviceStatisticsParams(dectTHPZoneId, dectTHPZoneType);
    }

    loadChosenGraph(graphTypeStr, offset = 0) {
        this.showModal('zoneGraphModal2');
        this.setCurrentDeviceStatisticsParams(graphTypeStr);
        //timeout for modal loading
        setTimeout(() => {

            this.genericLoadGraph(this._statisticGraphChartBindToName, graphTypeStr, this.getDectZoneMeasurements, offset);

        }, 200);
    }

    addUserDectStatisticsDeviceSelectionToLocalStorage() {
        this.$localStorage.dectStatistics[this.panelId] = this.selectedZone.values[0]._id.device_id;
    }

    selectedZoneChanged() {
        this.addUserDectStatisticsDeviceSelectionToLocalStorage();
        this._setLatestDectHomeAutomationMeasurements(this.selectedZone);
    }

    getUserEmail() {
        this.userEmail = this.ApiAccountService.getEmail();
        return this.userEmail;
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/controller.js
 **/